import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

import { HeaderComponent } from '../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';

import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';

import { ReajustePrecoService } from '../../../shared/services/apis/produto/reajuste-preco.service';
import { UsuarioService } from '../../../shared/services/apis/usuario/usuario.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { ReajustePrecoHistoricoStruct } from '../../../shared/services/structs/produto/reajuste-preco-historico.struct';
import { ReajustePrecoItemStruct } from '../../../shared/services/structs/produto/reajuste-preco-item.struct';

@Component({
  selector: 'app-reajuste-precos-visualizar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatTableModule, AbntPipe, HeaderComponent, LoadingBoxDefaultListComponent],
  templateUrl: './reajuste-precos-visualizar.component.html',
  styleUrl: './reajuste-precos-visualizar.component.css',
})
export class ReajustePrecosVisualizarComponent implements OnInit {
  public moduloEnum = ModuloEnum.Cadastros;
  public funcionalidadeEnum = FuncionalidadeEnum.Cadastros_ReajustePreco;

  public isLoading = false;
  public resumo?: ReajustePrecoHistoricoStruct;
  public itens: ReajustePrecoItemStruct[] = [];
  public nomeUsuario = '—';
  public displayedColumns: string[] = ['descricao', 'codigo', 'unidade', 'precoAnterior', 'precoAplicado', 'variacao'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reajustePrecoService: ReajustePrecoService,
    private usuarioService: UsuarioService,
    private alertService: AlertService,
    private authService: AuthService
  ) { }

  private get casasDecimaisPreco(): number {
    return this.authService.getUserInfos()?.casasDecimaisPreco || 2;
  }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!id) {
      this.voltar();
      return;
    }

    this.isLoading = true;
    this.reajustePrecoService.get(id).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError || !res.resumo) {
          this.alertService.show('Erro', res.errorDescription || 'Reajuste não encontrado.', AlertType.error);
          this.voltar();
          return;
        }
        this.resumo = res.resumo;
        this.itens = res.itens;
        this.carregarNomeUsuario(res.resumo.idUsuario);
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Não foi possível carregar o reajuste.', AlertType.error);
      },
    });
  }

  private carregarNomeUsuario(idUsuario: number): void {
    this.usuarioService.getAll().subscribe({
      next: res => {
        if (!res.isError) {
          this.nomeUsuario = res.listaUsuario.find(u => u.idUsuario === idUsuario)?.nomeUsuario ?? '—';
        }
      },
    });
  }

  public variacao(item: ReajustePrecoItemStruct): number {
    if (!item.precoAnterior) return 0;
    return ((item.precoAplicado - item.precoAnterior) / item.precoAnterior) * 100;
  }

  public voltar(): void {
    this.router.navigate(['/cadastross/reajuste-precos']);
  }

  public imprimir(): void {
    window.print();
  }

  public exportar(): void {
    const linhas = [['Descrição', 'Código', 'Unidade', 'Preço Anterior', 'Preço Aplicado', 'Variação (%)']];
    this.itens.forEach(item => {
      linhas.push([
        item.nome,
        item.codigoSku ?? '',
        item.unidadeMedida ?? '',
        item.precoAnterior.toFixed(this.casasDecimaisPreco),
        item.precoAplicado.toFixed(this.casasDecimaisPreco),
        this.variacao(item).toFixed(2),
      ]);
    });

    const csv = linhas.map(l => l.map(v => `"${v}"`).join(';')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `reajuste-${this.resumo?.idProdutoReajustePreco}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }
}
